import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { ArrowRight, ChevronLeft, ChevronRight, Phone, MessageCircle } from 'lucide-react';
import { company } from '../../mock';


export default function PageHero({ eyebrow, title, subtitle, image }) {
  const waLink = `https://wa.me/${company.whatsapp}?text=${encodeURIComponent('Hi Ewen Realtors, I want to know more about The Ewen Park.')}`;

  return (
    <section className="relative h-[84vh] min-h-[500px] flex items-end overflow-hidden bg-[#0f1a14]">
      <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-20" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0f1a14]/60 via-transparent to-[#0f1a14]/95" />
      <div className="relative mx-auto max-w-7xl w-full px-6 lg:px-10 pb-16">
        <div className="flex items-center gap-3 mb-5">
          <div className="h-px w-12 bg-[#c9a56a]" />
          <span className="text-[#c9a56a] text-xs uppercase tracking-[0.3em]">{eyebrow}</span>
        </div>
        <h1 className="font-serif text-white text-5xl md:text-7xl leading-[1.05] max-w-3xl">{title}</h1>
        {subtitle && <p className="text-white/75 mt-5 max-w-xl text-lg">{subtitle}</p>}
      </div>
      <div className="flex flex-wrap gap-3 mt-10">
              <Link to="/contact">
                <Button className="bg-[#0f1a14] hover:bg-[#1c2e26] text-white rounded-full px-8 py-6 text-sm tracking-wider">
                  Book a Site Visit <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </Link>
              <a href={`tel:${company.phoneRaw}`}>
                <Button variant="outline" className="bg-transparent border-[#0f1a14]/20 hover:bg-[#0f1a14] hover:text-white text-[#0f1a14] rounded-full px-6 py-6 text-sm tracking-wider">
                  <Phone className="h-4 w-4 mr-2" /> Call
                </Button>
              </a>
              <a href={waLink} target="_blank" rel="noreferrer">
                <Button variant="outline" className="bg-transparent border-[#0f1a14]/20 hover:bg-[#0f1a14] hover:text-white text-[#0f1a14] rounded-full px-6 py-6 text-sm tracking-wider">
                  <MessageCircle className="h-4 w-4 mr-2" /> WhatsApp
                </Button>
              </a>
            </div>
    </section>
  );
}
